export const mutation_update_item=`
mutation updateItem($userId: String!, $anagraficaId: Int!) {
    updateItem(userId: $userId, anagraficaId: $anagraficaId) {
        workspace_id
    }
}`;